export default __webpack_public_path__ + "static/propertysearchdesk1-2b792957ec359f25269ae74d5f46a59c.jpg";